module.exports = __webpack_public_path__ + "img/solu5.669f23fa.png";